import { ReactComponent as ContentCopy } from 'assets/icons/icon-content-copy.svg';

export default ContentCopy;
